import { useSearchParams } from 'marketplace-ui-common/hooks/useSearchParams';
const VALID_PRODUCT_TYPES = new Set(['APP', 'AGENT', 'SOLUTIONS_PARTNER_PROFILE']);
export function useProductTypeSearchParams() {
  const {
    getList
  } = useSearchParams();
  return getList('PRODUCT_TYPE').filter(v => VALID_PRODUCT_TYPES.has(v));
}
export function useProductTypeSearchParam() {
  const productTypes = useProductTypeSearchParams();
  return productTypes.length === 1 ? productTypes[0] : undefined;
}